import { Component } from '@angular/core';
import { TheInitiativeComponent } from '../the-initiative/the-initiative.component';
import { AtomoAtWorkComponent } from '../atomo-at-work/atomo-at-work.component';
import { PhotoSlidesComponent } from '../photo-slides/photo-slides.component';
import { NumberInInitiativesComponent } from '../number-in-initiatives/number-in-initiatives.component';
import { InitiativePartnersComponent } from '../initiative-partners/initiative-partners.component';
import { InitiativeMediaComponent } from '../initiative-media/initiative-media.component';

@Component({
  selector: 'app-our-initiatives',
  standalone: true,
  imports: [
    PhotoSlidesComponent,
    TheInitiativeComponent,
    AtomoAtWorkComponent,
    NumberInInitiativesComponent,
    InitiativePartnersComponent,
    InitiativeMediaComponent
  ],
  templateUrl: './our-initiatives.component.html',
  styleUrl: './our-initiatives.component.scss',
})
export class OurInitiativesComponent {}
